import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, Card, Row, Col } from "react-bootstrap";
import Spinner from "views/Spinner";

import { MdEdit } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";

import Errors from "Notifications/Errors";

import { validateForm } from "utils/validation";
import AppBreadcrumb from "../Layout/AppBreadCrumb";

import {
  cancelSave,
  setErrors,
  resetComponentStore,
  getSpecialtyById,
  removeSpecialtyErrors,
  updateSpecialty,
} from "actions/specialtyActions";

const EditSpecialty = ({
  updateSpecialty,
  setErrors,
  removeSpecialtyErrors,
  loadingSpecialty,
  currentSpecialty,
  errorList,
  getSpecialtyById,
  resetComponentStore,
}) => {
  const navigate = useNavigate();
  const { specialty_id } = useParams();

  const initialFormData = {
    name: "",
  };
  const [formData, setFormData] = React.useState(initialFormData);
  const [submitting, setSubmitting] = React.useState(false);
  const [isDisabled, setDisabled] = React.useState(true);
  const toggleEdit = () => setDisabled(!isDisabled);

  const loadSpecialtyFormData = (currentSpecialty) => {
    const { name } = currentSpecialty;

    const data = {
      name,
    };
    setFormData((formData) => ({ ...formData, ...data }));
  };

  const onClickHandel = (e) => {
    e.preventDefault();
    toggleEdit();
  };

  React.useEffect(() => {
    if (!currentSpecialty) return;

    loadSpecialtyFormData(currentSpecialty);
  }, [currentSpecialty]);

  const { name } = formData;

  const onChange = (e) => {
    if (!e.target) {
      return;
    }

    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    removeSpecialtyErrors();

    let validationRules = [
      {
        param: "name",
        msg: "Name is required.",
      },
    ];

    const errors = validateForm(formData, validationRules);

    if (errors.length) {
      setErrors(errors);
      return;
    }

    const submitData = {};

    for (let i in formData) {
      if (
        formData[i] === "" ||
        formData[i] === null ||
        formData[i] === undefined
      )
        continue;
      submitData[i] = formData[i];
    }

    setSubmitting(true);
    updateSpecialty(submitData, navigate, specialty_id).then((res) => {
      setSubmitting(false);
      toggleEdit();
    });
  };

  React.useMemo(() => {
    if (!specialty_id) return;

    resetComponentStore();

    getSpecialtyById(specialty_id);
  }, []);

  return (
    <React.Fragment>
      <AppBreadcrumb
        pageTitle="Edit Specialty"
        crumbs={[
          { name: "Specialties", path: "/admin/specialties" },
          { name: "Edit Specialty" },
        ]}
      />

      {loadingSpecialty ? (
        <Spinner />
      ) : (
        <Row>
          <Col xs="12" sm="6">
            <Card className="card-body">
              <Form onSubmit={(e) => onSubmit(e)} autoComplete="off">
                <div className="card-heading mb-3">
                  <h4 className="header-title mb-3">Specialty Information</h4>

                  <Button
                    variant="link"
                    size="sm"
                    className="float-end"
                    onClick={toggleEdit}
                  >
                    {isDisabled ? (
                      <span>
                        <MdEdit title="Click to Edit" size={20} />
                      </span>
                    ) : (
                      <span>
                        <FaRegEye title="View mode" size={20} />
                      </span>
                    )}
                  </Button>
                </div>

                <Form.Group className="form-group">
                  <Form.Label htmlFor="name">
                    Name <span>*</span>
                  </Form.Label>
                  <Form.Control
                    className={errorList.name ? "invalid" : ""}
                    type="text"
                    id="name"
                    name="name"
                    maxLength="12"
                    value={name}
                    onChange={(e) => onChange(e)}
                    disabled={isDisabled}
                  />
                  <Errors current_key="name" key="name" />
                </Form.Group>

                <br></br>

                <div className="float-end">
                  <Button
                    className="m-2"
                    type="submit"
                    variant="primary"
                    disabled={submitting || isDisabled}
                  >
                    {submitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {` Loading... `}
                      </>
                    ) : (
                      <>Save</>
                    )}
                  </Button>
                  <Button
                    className="ml-2"
                    type="reset"
                    variant="danger"
                    onClick={onClickHandel}
                    disabled={submitting || isDisabled}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

EditSpecialty.propTypes = {
  loadPage: PropTypes.func.isRequired,
  errorList: PropTypes.object.isRequired,
  cancelSave: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errorList: state.errors,
  loadingSpecialty: state.specialty.loadingSpecialty,
  currentSpecialty: state.specialty.currentSpecialty,
});

export default connect(mapStateToProps, {
  updateSpecialty,
  cancelSave,
  setErrors,
  removeSpecialtyErrors,
  resetComponentStore,
  getSpecialtyById,
  resetComponentStore,
})(EditSpecialty);
